import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import Footer from 'src/components/Footer'
import NewHeader from 'src/New Codes/components/NewHeader'
import { url } from 'src/helpers'
import { formatExperience, timeAgo } from './textUtils'
import './PublicPages.css'

const Careers = () => {
    const [jobs, setJobs] = useState([])
    const [loading, setLoading] = useState(true)
    const [department, setDepartment] = useState('')

    async function fetchData() {
        setLoading(true)
        try {
            const response = await fetch(url + 'careers/jobs')
            const data = await response.json()
            if (data?.status === 200) {
                setJobs(data?.data || [])
            } else {
                toast.error(data?.message)
            }
        } catch (err) {
            toast.error('Failed to load job openings')
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    const departments = useMemo(() => [...new Set(jobs.map((job) => job.department).filter(Boolean))], [jobs])
    const visibleJobs = department ? jobs.filter((job) => job.department === department) : jobs

    return (
        <>
            <NewHeader />
            <div className="public-page">
                <header className="pp-hero">
                    <div className="pp-wrap">
                        <span className="pp-eyebrow">Careers</span>
                        <h1>Careers at Beba Mzigo</h1>
                        <p>Join our team and help move Africa's logistics forward.</p>
                        {!loading && jobs.length > 0 && (
                            <div className="pp-stat"><b>{jobs.length}</b> open {jobs.length === 1 ? 'role' : 'roles'}</div>
                        )}
                    </div>
                </header>

                <div className="pp-wrap pp-wide pp-body-section">
                    {departments.length > 1 && (
                        <div className="pp-filters">
                            <button type="button" className={`pp-chip ${!department ? 'on' : ''}`} onClick={() => setDepartment('')}>All</button>
                            {departments.map((name) => (
                                <button type="button" key={name} className={`pp-chip ${department === name ? 'on' : ''}`} onClick={() => setDepartment(name)}>{name}</button>
                            ))}
                        </div>
                    )}

                    {loading ? (
                        <div className="pp-state">Loading...</div>
                    ) : visibleJobs.length > 0 ? (
                        <div className="cr-grid">
                            {visibleJobs.map((job) => (
                                <Link to={`/careers/${job?._id}`} className="cr-card" key={job?._id}>
                                    {job?.department && <span className="cr-dept">{job.department}</span>}
                                    <h3>{job?.title}</h3>
                                    <div className="cr-facts">
                                        {job?.experience && <span className="cr-fact"><i className="fa fa-briefcase"></i>{formatExperience(job.experience)} experience</span>}
                                        {job?.salary && <span className="cr-fact"><i className="fa fa-money"></i>{job.salary}</span>}
                                    </div>
                                    <div className="cr-foot">
                                        <span>Posted {timeAgo(job?.created_at)}</span>
                                        <span className="go">View &amp; apply <i className="fa fa-arrow-right" style={{ marginLeft: 4 }}></i></span>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    ) : (
                        <div className="pp-state">
                            <i className="fa fa-briefcase"></i>
                            <p>There are no open positions right now. Please check back later.</p>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Careers
